export default __webpack_public_path__ + "static/media/img (2).2f6a2e18.jpg";